'use strict';

import '../../css/components/donation-amount.scss';
import { donationAmountElements } from "./elements/donationAmountElements";

export default class DonationAmountOther
{
    constructor() {
        this.elements = donationAmountElements();
        this.changeDonationAmountSelect = this.onChangeDonationAmountSelect.bind(this);
        this.addEventListeners();
    }

    addEventListeners() {
        this.elements.donationAmountSelect.forEach(element => {
            element.addEventListener('change', this.changeDonationAmountSelect);
        });
    }

    onChangeDonationAmountSelect(event) {
        const target = event.currentTarget;
        if (target.value === 'other') {
            this.elements.donationAmountOther.style.display = 'inherit';
        } else {
            this.elements.donationAmountOther.style.display = 'none';
        }
    }
}
